module.exports = __webpack_public_path__ + "static/media/person-services.89cab515.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/whoCanBFromElla/person-services.svg
// module id = 138
// module chunks = 0